import { Box, Checkbox, Input, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { Control, Controller } from "react-hook-form";
import { useIntl } from "react-intl";

import { messages } from "./messages";
import { ShippingFormValues } from "./types";

export const SHIPPING_FORM_ID = "wizard-shipping-form";

interface ShippingFormProps {
  control: Control<ShippingFormValues>;
  countryChoices: Array<{ label: string; value: string }>;
  disabled: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

export const ShippingForm: React.FC<ShippingFormProps> = ({
  control,
  countryChoices,
  disabled,
  onSubmit,
}) => {
  const intl = useIntl();

  return (
    <form id={SHIPPING_FORM_ID} onSubmit={onSubmit}>
      <Box display="flex" flexDirection="column" gap={4}>
        <Controller
          name="name"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              label={intl.formatMessage(messages.zoneName)}
              error={!!fieldState.error}
              helperText={
                fieldState.error?.message ??
                intl.formatMessage(messages.zoneNameHelper)
              }
              disabled={disabled}
              size="large"
            />
          )}
        />

        <Controller
          name="description"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              label={intl.formatMessage(messages.zoneDescription)}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              disabled={disabled}
              size="large"
            />
          )}
        />

        <Box>
          <Text fontWeight="bold" paddingBottom={2} as="p">
            {intl.formatMessage(messages.countriesTitle)}
          </Text>
          <Text size={2} color="default2" paddingBottom={3} as="p">
            {intl.formatMessage(messages.countriesDescription)}
          </Text>
          <Controller
            name="countries"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Box
                __maxHeight="300px"
                overflow="auto"
                borderWidth={1}
                borderStyle="solid"
                borderColor="default1"
                borderRadius={4}
                padding={3}
              >
                <Box display="flex" flexDirection="column" gap={2}>
                  {countryChoices.map(country => (
                    <Checkbox
                      key={country.value}
                      checked={value.includes(country.value)}
                      onCheckedChange={checked => {
                        if (checked) {
                          onChange([...value, country.value]);
                        } else {
                          onChange(
                            value.filter(
                              (c: string) => c !== country.value,
                            ),
                          );
                        }
                      }}
                      disabled={disabled}
                    >
                      <Text size={2}>{country.label}</Text>
                    </Checkbox>
                  ))}
                </Box>
              </Box>
            )}
          />
        </Box>
      </Box>
    </form>
  );
};
